export default class CartSubmitInput extends HTMLFormElement
{
    constructor() {
        super();

        this.generalConditionBtn = document.querySelector('#condition_btn');
        this.generalConditionBtnError = document.querySelector('#condition_btn_error');
        this.paymentSelectors = document.querySelectorAll("input.payment-selector");
        this.paymentSelectorError = document.querySelector("#payment_selector_error");

    }

    connectedCallback()
    {
        this.addEventListener('submit', e => {
            e.preventDefault();

            this.generalConditionBtnError.style.display = "none";
            this.paymentSelectorError.style.display = "none";

            let checkCguAndPaymentMode = true;

            if ( ! this.generalConditionBtn.checked) {
                this.generalConditionBtnError.style.display = "";
                checkCguAndPaymentMode = false;
            }

            if( ! this.checkPaymentModeSelected()) {
                this.paymentSelectorError.style.display = "";
                checkCguAndPaymentMode = false;
            }

            if (checkCguAndPaymentMode) {
                // Vérification en ajax du statut du panier
                this.prePaymentCheck().then((result) => {
                    if (result) {
                        // Si tous les feux sont au vert, on peut soumettre le formulaire
                        this.submit();
                    }
                });
            }
        });
    }

    /**
     * Vérifie qu'un mode de paiement soit sélectionné dans la liste.
     */
    checkPaymentModeSelected() {
        for (let input of this.paymentSelectors) {
            if (input.checked) {
                return true;
            }
        }

        return false;
    }

    /**
     * Envoie une requête ajax pour vérifier que le panier peut être payé
     * et passer dans le cas d'un paiement CB le statut du panier à LOCKED_FOR_PAYMENT.
     * @return bool
     */
    async prePaymentCheck() {
        return await fetch(this.dataset.checkCartUrl, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                _token: this.getCsrfToken(),
            }),
        }).then((response) => {
            /*
             * Traitement du retour :
             * - 200 si le panier est ok pour paiement
             * - 423 si le panier est déjà en cours de paiement
             */
            if (response.status !== 200) {
                response.json().then((json) => {
                    toastr.error(json.message);
                });

                return false;
            }

            return true;
        });
    }

    /**
     * Retourne le token CSRF contenu dans le champ #_token, ailleurs dans le document.
     * @returns {string|null}
     */
    getCsrfToken() {
        const csrfInput = document.getElementById('_token');
        if (csrfInput) {
            return csrfInput.value;
        }

        return null;
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/front/components/CartSubmitInput.js